import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createComment } from '../../api/reviews';

export default function CommentForm({ eventPk, requireLogin }) {
    const [content, setContent] = useState('');
    const queryClient = useQueryClient();

    const createMutation = useMutation({
        mutationFn: () => createComment(eventPk, { content }),
        onSuccess: () => {
            setContent('');
            queryClient.invalidateQueries({ queryKey: ['comments', eventPk] });
        },
        onError: () => alert('Failed to post comment. Please try again.'),
    });

    const handleSubmit = () => {
        if (!content.trim()) return;
        if (!requireLogin('comment')) return;
        createMutation.mutate();
    };

    return (
        <div className="comment-form">
            <textarea
                placeholder="add a comment..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
            />
            <div className="comment-form-footer">
                <button
                    className="comment-submit-btn"
                    onClick={handleSubmit}
                    disabled={createMutation.isPending || !content.trim()}
                >
                    {createMutation.isPending ? 'Submitting...' : 'Submit'}
                </button>
            </div>
        </div>
    );
}
